import { neutral200, blue400, primary200 } from '../themes/colors';

export const toggleVariants = [
	'default',
	'dark',
] as const;

export type ToggleVariant = typeof toggleVariants[number];

export type ToggleVariantDefinition = {
	shadow: boolean;
	trackColor: string;
	trackActiveColor: string;
};

export const ToggleVariants: {[key in ToggleVariant]: ToggleVariantDefinition} = {
	default: {
		shadow: true,
		trackColor: neutral200,
		trackActiveColor: blue400,
	},
	dark: {
		shadow: true,
		trackColor: primary200,
		trackActiveColor: blue400,
	},
};
